module.exports = __webpack_public_path__ + "img/advantage4@2x.9507d2a9.png";